if (window.location.hash) {
    $('[data-activeform]').attr('data-activeform', window.location.hash.substr(1));
}

$('[data-setactiveform]').click(function () {
    let active = $(this).attr('data-setactiveform');
    $('[data-activeform]').attr('data-activeform', active);
    window.history.replaceState({}, '', window.location.pathname + '#' + active);
});
